<template>
  <div class="el-form-item item">
    <!-- 搜索项 -->
    <el-select class="label" v-model="curSearchKey" placeholder="请选择" @change="onKeyChange" filterable>
      <el-option v-for="(n, i) in options" :key="n.label + i" :label="n.label" :value="n.value">
      </el-option>
    </el-select>
    <!-- 下拉搜索框 -->
    <el-select class="value" v-model="curSearchValue" :placeholder="placeholder || '请选择'" @change="onValueChange"
      filterable :multiple="multiple" :clearable="clearable">
      <el-option v-for="(n, i) in valueOptions" :key="n.label + i" :label="n.label" :value="n.value">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    options: Array,
    valueOptionsData: Object,
    multiple: Boolean,
    clearable: Boolean,
    placeholder: String,
  },
  data() {
    return {
      curSearchKey: undefined,
      curSearchValue: undefined,
      valueOptions: [],
    };
  },
  watch: {
    options: {
      deep: true,
      handler(newVal) {
        console.log(newVal, this.options)
        if (newVal && newVal[0]) {
          this.curSearchKey = newVal[0].value
        }
      },
    },
    curSearchKey: {
      deep: true,
      handler(newVal, oldVal) {
        // console.log(newVal, oldVal)
        // 键名变换时重置旧的键值，避免隐性的搜索
        this.$emit("onChange", {
          key: oldVal,
          value: '',
        });
      },
    },
  },
  computed: {
    ...mapState([
      'user',
      'store',
    ]),
  },
  methods: {
    onKeyChange(v) {
      // console.log(v, typeof v);
      this.curSearchKey = v
      this.curSearchValue = undefined
      // 设置新的options
      this.setValueOptions()
    },
    onValueChange(v) {
      // console.log(this.curSearchKey, v, typeof v);
      this.$emit("onChange", {
        key: this.curSearchKey,
        value: v,
      });
    },
    setNormalKey() {
      if (this.options && this.options[0]) {
        this.curSearchKey = this.options[0].value
        this.setValueOptions()
      }
    },
    setValueOptions() {
      this.$nextTick(() => {
        this.valueOptions = this.valueOptionsData[this.curSearchKey] || []
      })
    },
    reset() {
      this.setNormalKey()
      this.curSearchValue = undefined
    },
  },
  mounted() {
    // 首先设置默认值
    this.setNormalKey()
    // 获取存储的搜索参数
    // console.log('store', { ...this.store })
    const path = this.$route.path
    if (this.store && this.store['formInline' + path]) {
      const formInline = this.store['formInline' + path]
      this.$forceUpdate()
      // console.log('formInline 1', { ...formInline })
      // console.log('options', this.options)
      this.options.map(v => {
        const key = v.value
        // 匹配数据设置储存的值
        if (Object.hasOwnProperty.call(formInline, key) && formInline[key]) {
          this.curSearchKey = key
          this.curSearchValue = formInline[key]
        }
      })
    }
  },
};
</script>

<style lang="less" scoped>
.el-form-item {
  margin-right: 20px;

  .label {
    /deep/ .el-input {
      width: 120px;

      .el-input__inner {
        border-right-width: 0;
        border-radius: 4px 0 0 4px;

        &:focus {
          border-right-width: 1px;
        }
      }
    }
  }

  >.value {

    /deep/.el-input__inner {
      border-radius: 0 4px 4px 0;
    }
  }

}
</style>
